<template>
  <div class="card">
    <div class="card-header">
      <h3 class="card-title inline">Yearly Banker Summary</h3>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label">Year</label>
            <select class="form-control custom-select" v-model="form.year">
              <option value>-Select-</option>
              <option v-for="(item, index) in years" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label class="form-label">Bank</label>
            <select class="form-control custom-select" v-model="form.bank">
              <option value>-Select-</option>
              <option
                v-for="(item, index) in banks"
                :key="index"
                :value="item.bank_name"
              >
                {{ item.bank_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label class="form-label">&nbsp;</label>
            <button
              type="button"
              @click="filterReport"
              class="btn btn-primary"
              :disabled="form.year == '' || form.bank == ''"
            >
              Filter
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Bank</th>
                  <th scope="col">Banker</th>
                  <th scope="col">Total Amount</th>
                  <th scope="col">Total Cases</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in reports" :key="index">
                  <td>
                    <span v-if="index == 0">
                      {{ item.bank_name }}
                    </span>
                  </td>
                  <td>{{ item.manager.name }}</td>
                  <td>{{ item.amount | currency }}</td>
                  <td>{{ item.total }}</td>
                </tr>
                <tr v-if="reports.length == 0">
                  <td colspan="4" class="text-center">No records found!</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      years: [],
      banks: [],
      form: {
        year: "",
        bank: "",
      },
      reports: [],
    };
  },
  methods: {
    filterReport() {
      this.$http
        .post(this.rootUrl + "report/yearly-banker-summary", this.form)
        .then(
          (res) => {
            this.refreshToken(res);
            this.reports = res.data;
          },
          (err) => {
            if (typeof err.response !== "undefined") {
              this.$snotify.error(err.response.data.message, "Valuation", {
                timeout: 4000,
                showProgressBar: false,
                position: "rightTop",
              });
            } else {
              console.log(JSON.parse(JSON.stringify(err)));
            }
          }
        );
    },
  },
  mounted() {
    this.$http.get(this.rootUrl + "report/years", this.corsConfig).then(
      (res) => {
        this.refreshToken(res);
        this.years = res.data.years;
      },
      (err) => {
        if (typeof err.response !== "undefined") {
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
        } else {
          console.log(JSON.parse(JSON.stringify(err)));
        }
      }
    );

    this.$http.get(this.rootUrl + "report/banks", this.corsConfig).then(
      (res) => {
        this.refreshToken(res);
        this.banks = res.data;
      },
      (err) => {
        if (typeof err.response !== "undefined") {
          this.$snotify.error(err.response.data.message, "Valuation", {
            timeout: 4000,
            showProgressBar: false,
            position: "rightTop",
          });
        } else {
          console.log(JSON.parse(JSON.stringify(err)));
        }
      }
    );
  },
};
</script>
